/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Order_NoteInputs */

const vi_shop_home_order_note = /** @type {(inputs: Shop_Home_Order_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ tự các khối trên trang do code cố định; kéo thả chỉ đổi thứ tự trong một khối.`)
};

/**

* @param {Shop_Home_Order_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_order_note = /** @type {((inputs?: Shop_Home_Order_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Order_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_order_note(inputs)
});